import {
  faCalendar,
  faCar,
  faCheck,
  faCheckCircle,
  faClock,
  faCopy,
  faHourglassEnd,
  faPhoneSlash,
  faPhoneVolume,
  faUserCheck,
} from "@fortawesome/fontawesome-free-solid";
import {
  faArrowRightArrowLeft,
  faLocationDot,
  faPhoneFlip,
  faSignsPost,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import copy from "copy-to-clipboard";
import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const ManageBookingItem = ({
  bookingId,
  Bookingtype,
  pickupLocation,
  dropofLocation,
  travelDate,
  travelDistance,
  travelTime,
  amount,
  currency,
  driverName,
  driverContact,
  driverCountryCode,
  vehicletype,
  bookingStatus,
  affiliateDetails,
  duration,
  spreq,
  affiliateNote,
}) => {
  const [copyMsg, setcopyMsg] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setcopyMsg(false);
    }, 5000);
  }, [copyMsg]);

  const handleClick = (id) => () => {
    copy(id);
    setcopyMsg(true);
  };

  const { profileBoxAction } = useSelector((state) => state.auth);
  return (
    <>
      {/* --------------------- screen size from lg -------------------------- */}

      <div className="cardBorder1 borderFN h-min">
        <div id="grad" className="rounded-lg bg-[#121010] h-full">
          <div className="sm:flex justify-between rounded-lg bg-gradient-to-r from-[#0c0c0c] via-[#444444] to-[#0c0c0c] px-5 py-2">
            <div className="flex space-x-1 items-center relative">
              <div className="font-semibold text-lg text-gray-200">
                Booking ID:
              </div>
              <div className="text-lg font-bold text-[#00E0FF]">
                {bookingId}
              </div>
              <span onClick={handleClick(bookingId)}>
                <FontAwesomeIcon
                  icon={faCopy}
                  className="w-4 cursor-pointer text-slate-600 pl-3"
                />
              </span>
              {copyMsg && (
                <div className="text-xs italic  text-gray-500 animate__animated animate__fadeIn absolute translate-x-60">
                  Copied
                </div>
              )}
            </div>

            {/* <div className="flex items-center space-x-3 ">
            <div className="flex items-center space-x-2">
              <div className="text-base text-labelcolor font-semibold">
                Price:
              </div>
              <div className="flex items-center space-x-1">
                <div className="text-lg font-semibold text-drivadocolor">
                  {currency}
                </div>
                <div className="text-lg font-semibold text-fieldcolor">
                  {amount ? Math.round(amount) : 0}
                </div>
              </div>
            </div>
          </div> */}
          </div>
          {/* secondary details */}
          <Link to={profileBoxAction ? `` : `/ordermanage/${bookingId}`}>
            <div className="py-6 px-5 lg:flex lg:justify-between lg:space-x-4 space-y-2 lg:space-y-0 cursor-pointer">
              <div className="space-y-2.5  xl:w-[40%] 2xl:w-1/3">
                <BookingDetailItem
                  iconname={faLocationDot}
                  label="Pick Up"
                  value={pickupLocation}
                  className="2xl:w-[600px]"
                />
                {dropofLocation && (
                  <BookingDetailItem
                    iconname={faLocationDot}
                    label="Drop Off"
                    value={dropofLocation}
                    className="2xl:w-96"
                  />
                )}

                <BookingDetailItem
                  iconname={faArrowRightArrowLeft}
                  label="Booking Type"
                  value={
                    Bookingtype?.charAt(0)?.toUpperCase() +
                    Bookingtype?.slice(1).toLowerCase()
                  }
                />
                <BookingDetailItem
                  iconname={faCheckCircle}
                  label="Affiliate Note"
                  value={affiliateNote ? affiliateNote : "--"}
                />
                <BookingDetailItem
                  iconname={faHourglassEnd}
                  label="Duration"
                  value={duration}
                />
                <div className="hidden lg:block xl:hidden">
                  <BookingDetailItem
                    label="Vehicle Type"
                    value={vehicletype}
                    isCondition={true}
                    customFont={"text-white font-semibold lg:text-xl"}
                    labelFont={"text-white font-semibold lg:text-xl"}
                  />
                  <BookingDetailItem
                    label="Price"
                    value={`${currency} ${amount ? Math.round(amount) : 0}`}
                    isCondition={true}
                    customFont={"text-[#00E0FF] font-semibold text-xl"}
                    labelFont={"text-white font-semibold text-lg"}
                  />
                </div>
                {/* <BookingDetailItem
                iconname={faSignsPost}
                label="Distance"
                value={Math.round(travelDistance) + " km"}
              /> */}
              </div>
              <div className="space-y-2.5 xl:w-[30%] 2xl:w-1/3">
                {/* <BookingDetailItem
                iconname={faCalendar}
                label="Booking Date"
                value={moment(createdAt).format("DD MMM YYYY")}
              /> */}
                <BookingDetailItem
                  iconname={faCalendar}
                  label="Travel Date"
                  value={moment(travelDate?.split("T")[0]).format(
                    "DD MMM YYYY"
                  )}
                />
                <BookingDetailItem
                  iconname={faClock}
                  label="Travel Time"
                  value={travelTime}
                />

                <BookingDetailItem
                  iconname={faCheck}
                  label="Booking Status"
                  value={bookingStatus}
                  isCondition={true}
                  customFont={`${
                    bookingStatus === "COMPLETED"
                      ? "text-green-600 font-semibold text-sm"
                      : bookingStatus === "CANCELLED"
                      ? "text-red-600"
                      : "text-green-600"
                  } text-gray-700 font-semibold text-sm`}
                />

                {/* <div className="flex items-center space-x-3">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="w-5 h-5 text-white"
                />
                <div className="text-base text-white font-semibold w-32">
                  Booking Status{" "}
                </div>
                <div
                  className={`${
                    bookingStatus === "COMPLETED"
                      ? "text-yellow-600 font-semibold text-sm"
                      : bookingStatus === "CANCELLED"
                      ? "text-red-600"
                      : "text-[#B0901E]"
                  } text-gray-700 font-semibold text-sm `}
                >
                  {bookingStatus}
                </div>
              </div> */}
                {/* <BookingDetailItem
                iconname={faUserCheck}
                label="Assigned to"
                value={affiliateDetails?.affiliateName}
              /> */}
                <BookingDetailItem
                  iconname={faUserCheck}
                  label="Driver Name"
                  value={driverName}
                  isCondition={
                    driverName === "Driver not assigned!" ? true : false
                  }
                  customFont={"text-red-600"}
                />
                <BookingDetailItem
                  iconname={faPhoneVolume}
                  label="Driver Number"
                  value={`${driverCountryCode} ${driverContact}`}
                />
                {/* <div className="flex space-x-3 items-center">
                <FontAwesomeIcon icon={faCar} className="w-5 h-5 text-white" />
                <div className="text-base text-white font-semibold w-32">
                  Vehicle Type:
                </div>
                <div className="text-xs font-semibold text-fieldcolor">
                  {vehicletype}
                </div>
              </div> */}
              </div>
              <div className="space-y-2.5 xl:w-[30%] 2xl:w-1/3 lg:hidden xl:block">
                <BookingDetailItem
                  label="Vehicle Type"
                  value={vehicletype}
                  isCondition={true}
                  customFont={
                    "text-white font-bold text-base sm:text-2xl 2xl:text-2xl"
                  }
                  labelFont={
                    "text-white sm:font-bold text-base sm:text-xl 2xl:text-lg"
                  }
                />
                <BookingDetailItem
                  label="Price"
                  value={`${currency} ${amount ? Math.round(amount) : 0}`}
                  isCondition={true}
                  customFont={"text-[#00E0FF] sm:font-bold sm:text-2xl"}
                  labelFont={
                    "text-white sm:font-bold text-base sm:text-xl 2xl:text-lg"
                  }
                />
              </div>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default ManageBookingItem;

export const BookingDetailItem = ({
  iconname,
  label,
  value,
  isCondition,
  customFont,
  labelFont,
}) => {
  return (
    <div className="flex md:items-center sm:space-x-3">
      <FontAwesomeIcon
        icon={iconname}
        className="w-5 h-5 text-white hidden sm:block"
      />
      <div
        className={`${
          isCondition
            ? `${labelFont}`
            : "text-sm sm:text-base text-[#fafafa] font-semibold"
        } text-white text-sm sm:text-base font-semibold w-40 sm:w-32`}
      >
        {label}:{" "}
      </div>
      <div
        className={`${
          isCondition
            ? `${customFont}`
            : "text-gray-300 font-normal text-sm sm:text-base"
        }  w-full sm:w-96 md:w-96 lg:w-60 2xl:w-96 lg:truncate`}
      >
        {value}
      </div>
    </div>
  );
};
